import { render, staticRenderFns } from "./KaiConversation.vue?vue&type=template&id=55fe53e3&scoped=true&"
import script from "./KaiConversation.vue?vue&type=script&lang=ts&"
export * from "./KaiConversation.vue?vue&type=script&lang=ts&"
import style0 from "./KaiConversation.vue?vue&type=style&index=0&id=55fe53e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fe53e3",
  null
  
)

export default component.exports